export default __webpack_public_path__ + "static/article-image-e709bd16300931ae8eb2b07fedd3dec6.png";